module.exports = __webpack_public_path__ + "067b3f01a0e7cb95bbffa8a391d1d99f.png";